import React from 'react';
import Paper from '@mui/material/Paper';
import { useGetBrands } from '../../api/hooks/inventory';
import Table from '../common/table';

export default function BrandsTable() {
  const { data } = useGetBrands();
  return (
    <Paper variant="outlined" sx={{ width: '100%' }}>
      <Table columns={columns} rows={data} />
    </Paper>
  );
}

const columns = [{ id: 'name', label: 'نام برند', minWidth: 70 }];
